import { init as initOrigin } from '@rematch/core/dist/cjs';
import * as models from './models';

// eslint-disable-next-line
export function init(config) {
  return initOrigin({
    ...config,
    // 继承全局 models
    models: { ...models, ...config.models }
  });
}
